import { render, staticRenderFns } from "./EditRates.vue?vue&type=template&id=73c99b8d&scoped=true&"
import script from "./EditRates.vue?vue&type=script&lang=js&"
export * from "./EditRates.vue?vue&type=script&lang=js&"
import style0 from "./EditRates.vue?vue&type=style&index=0&id=73c99b8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c99b8d",
  null
  
)

export default component.exports